import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';

import Layout from './components/layout';
import ScrollToTop from './components/common/ScrollToTop';
import AuthGuard from './components/common/AuthGuard';
import ProtectedRoute from './components/common/ProtectedRoute';
import { ClearCouponOnRouteChange } from './components/common/ClearCouponOnRouteChange ';
import LazyComponent from './components/common/LazyComponent';

import { useDeviceId } from './utils/functions/useDeviceId';
import { useGetCartQuery } from './utils/store/cart/CartApi';
import { setCart } from './utils/store/cart/CartSlice';
import { AppDispatch, RootState } from './utils/store';
import ValidateEmailLink from './pages/ValidateEmailLink';
import { useAuthWatcher } from './utils/functions/useAuthWatcher';
const Home = LazyComponent(() => import('./pages/Home'), 'page');
const ProductLists = LazyComponent(() => import('./pages/ProductLists'), 'page');
const ProductDetails = LazyComponent(() => import('./pages/ProductDetails'), 'page');
const Cart = LazyComponent(() => import('./pages/Cart'), 'page');
const Prescription = LazyComponent(() => import('./pages/Prescription'), 'page');
const Substitute = LazyComponent(() => import('./pages/Substitute'), 'page');
const MyAccount = LazyComponent(() => import('./pages/MyAccount'), 'page');
const TrackOrder = LazyComponent(() => import('./pages/TrackOrder'), 'page');
const Login = LazyComponent(() => import('./pages/Login'), 'page');
const SignUp = LazyComponent(() => import('./pages/Signup'), 'page');
const Blog = LazyComponent(() => import('./pages/Blog'), 'page');
const Offers = LazyComponent(() => import('./pages/Offers'), 'page');
const PageNotFound = LazyComponent(() => import('./pages/PageNotFound'), 'page');
const Thankyou = LazyComponent(() => import('./pages/Thankyou'), 'page');
const PaymentFailed = LazyComponent(() => import('./pages/PaymentFailed'), 'page');
const AllCategory = LazyComponent(() => import('./pages/AllCategory'), 'page');
const AllBrand = LazyComponent(() => import('./pages/AllBrand'), 'page');
const AllHealthCondition = LazyComponent(() => import('./pages/AllHealthCondition'), 'page');
const CartSummary = LazyComponent(() => import('./pages/CartSummary'), 'page');
const Checkout = LazyComponent(() => import('./pages/Checkout'), 'page');
const Pages = LazyComponent(() => import('./pages/Pages'), 'page');
const NeedHelp = LazyComponent(() => import('./pages/NeedHelp'), 'page');


const App = () => {
  const deviceId = useDeviceId();
  const dispatch = useDispatch<AppDispatch>();
  const { authData } = useSelector((state: RootState) => state.auth);
  useAuthWatcher();

  const { data: cartData } = useGetCartQuery(
    { unique_id: deviceId, user_id: authData?.id },
    { skip: !deviceId }
  );

  useEffect(() => {
    if (cartData) {
      dispatch(setCart(cartData));
    }
  }, [cartData, dispatch]);

  return (
    <Layout>
      <ClearCouponOnRouteChange />
      <ScrollToTop />
      <Routes>
        <Route element={<AuthGuard />}>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route path="/thanks/:id" element={<Thankyou />} />
          <Route path="/failed/:id" element={<PaymentFailed />} />
          <Route path="/myaccount/:name" element={<MyAccount />} />
          <Route path="/cart/summary" element={<CartSummary />} />
          <Route path="/cart/checkout" element={<Checkout />} />
          <Route path="/prescription" element={<Prescription />} />
          <Route path="/trackorder/:id" element={<TrackOrder />} />
        </Route>

        <Route path="/" element={<Home />} />
        <Route path="/substitute" element={<Substitute />} />
        <Route path="/categories/:id" element={<ProductLists />} />
        <Route path="/detail/:id" element={<ProductDetails />} />
        <Route path="/cart" element={<Cart />} />
        {/* <Route path="/blog" element={<Blog />} /> */}
        <Route path="/offers" element={<Offers />} />
        <Route path="/category" element={<AllCategory />} />
        <Route path="/brand" element={<AllBrand />} />
        <Route path="/faq-help" element={<NeedHelp />} />
        <Route path="/validate-email" element={<ValidateEmailLink />} />
        <Route path="/pages/:slug" element={<Pages />} />
        <Route path="/health-conditions" element={<AllHealthCondition />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Layout>
  );
};

export default App;
